// ============================================
// PRODUCT FILTER — Toggle, badge, tags, modal
// ============================================
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        // Bail if not on products page
        if (!document.querySelector('.product-filter')) return;

        // ---- DOM references ----
        var desktopChips = document.querySelectorAll('.product-filter__chip');
        var modalChips = document.querySelectorAll('.product-filter-modal__chip');
        var trigger = document.querySelector('.product-filter__trigger');
        var badge = document.querySelector('.product-filter__badge');
        var activeSection = document.querySelector('.product-filter__active');
        var tagsContainer = document.querySelector('.product-filter__tags');
        var modal = document.querySelector('.product-filter-modal');
        var modalClose = document.querySelector('.product-filter-modal__close');
        var modalClear = document.querySelector('.product-filter-modal__clear');
        var modalSubmit = document.querySelector('.product-filter-modal__submit');
        var productCards = document.querySelectorAll('.product-card');

        // Desktop active row
        var activeRow = document.querySelector('.product-filter__active-row');
        var activeRowTags = document.querySelector('.product-filter__active-row-tags');
        var clearBtn = document.querySelector('.product-filter__clear-btn');

        // ---- State ----
        var selectedFilters = { line: [], format: [] };

        // ---- Helpers ----
        function getChipKey(chip) {
            return chip.getAttribute('data-filter');
        }
        function getChipValue(chip) {
            return chip.getAttribute('data-value');
        }
        function getChipLabel(chip) {
            var textEl = chip.querySelector('.product-filter__chip-text, .product-filter-modal__chip-text');
            return textEl ? textEl.textContent.trim() : '';
        }

        // ---- Toggle chip selection ----
        function toggleChip(chip) {
            var filter = getChipKey(chip);
            var value = getChipValue(chip);
            var selectedClass = chip.classList.contains('product-filter__chip')
                ? 'product-filter__chip--selected'
                : 'product-filter-modal__chip--selected';

            if (chip.classList.contains(selectedClass)) {
                chip.classList.remove(selectedClass);
                selectedFilters[filter] = selectedFilters[filter].filter(function (v) { return v !== value; });
            } else {
                chip.classList.add(selectedClass);
                selectedFilters[filter].push(value);
            }
        }

        // ---- Sync between desktop and modal chips ----
        function syncChips(sourceChip) {
            var filter = getChipKey(sourceChip);
            var value = getChipValue(sourceChip);
            var isSelected = selectedFilters[filter].indexOf(value) !== -1;

            // Sync desktop chips
            desktopChips.forEach(function (c) {
                if (getChipKey(c) === filter && getChipValue(c) === value) {
                    c.classList.toggle('product-filter__chip--selected', isSelected);
                }
            });

            // Sync modal chips
            modalChips.forEach(function (c) {
                if (getChipKey(c) === filter && getChipValue(c) === value) {
                    c.classList.toggle('product-filter-modal__chip--selected', isSelected);
                }
            });
        }

        // ---- Update badge counter ----
        function updateBadge() {
            var totalCount = selectedFilters.line.length + selectedFilters.format.length;
            if (badge) {
                if (totalCount > 0) {
                    badge.style.display = '';
                    badge.textContent = totalCount;
                } else {
                    badge.style.display = 'none';
                }
            }
        }

        // ---- Build tag HTML ----
        function createTagHTML(label) {
            return '<span class="filter-tag__text">' + label + '</span>' +
                '<button type="button" class="filter-tag__close" aria-label="Usuń filtr ' + label + '">' +
                '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
                '</button>';
        }

        // ---- Update mobile active filter tags ----
        function updateMobileTags() {
            if (!tagsContainer || !activeSection) return;

            tagsContainer.innerHTML = '';
            var totalCount = selectedFilters.line.length + selectedFilters.format.length;

            if (totalCount === 0) {
                activeSection.style.display = 'none';
                return;
            }

            activeSection.style.display = '';

            Object.keys(selectedFilters).forEach(function (filterKey) {
                selectedFilters[filterKey].forEach(function (value) {
                    var label = value;
                    desktopChips.forEach(function (c) {
                        if (getChipKey(c) === filterKey && getChipValue(c) === value) {
                            label = getChipLabel(c);
                        }
                    });

                    var tag = document.createElement('span');
                    tag.className = 'filter-tag';
                    tag.setAttribute('data-filter', filterKey);
                    tag.setAttribute('data-value', value);
                    tag.innerHTML = createTagHTML(label);

                    tag.querySelector('.filter-tag__close').addEventListener('click', function () {
                        removeFilter(filterKey, value);
                    });

                    tagsContainer.appendChild(tag);
                });
            });
        }

        // ---- Update desktop active filters row ----
        function updateDesktopActiveRow() {
            if (!activeRow || !activeRowTags) return;

            activeRowTags.innerHTML = '';
            var totalCount = selectedFilters.line.length + selectedFilters.format.length;

            if (totalCount === 0) {
                activeRow.style.display = 'none';
                return;
            }

            activeRow.style.display = '';

            Object.keys(selectedFilters).forEach(function (filterKey) {
                selectedFilters[filterKey].forEach(function (value) {
                    var label = value;
                    desktopChips.forEach(function (c) {
                        if (getChipKey(c) === filterKey && getChipValue(c) === value) {
                            label = getChipLabel(c);
                        }
                    });

                    var tag = document.createElement('span');
                    tag.className = 'filter-tag';
                    tag.setAttribute('data-filter', filterKey);
                    tag.setAttribute('data-value', value);
                    tag.innerHTML = createTagHTML(label);

                    tag.querySelector('.filter-tag__close').addEventListener('click', function () {
                        removeFilter(filterKey, value);
                    });

                    activeRowTags.appendChild(tag);
                });
            });
        }

        // ---- Remove a single filter ----
        function removeFilter(filterKey, value) {
            selectedFilters[filterKey] = selectedFilters[filterKey].filter(function (v) { return v !== value; });
            // Sync chips to reflect removal
            syncChips({ getAttribute: function (attr) { if (attr === 'data-filter') return filterKey; if (attr === 'data-value') return value; } });
            updateAll();
        }

        // ---- Filter product cards (animated) ----
        var filterAnimationTimer = null;
        var STAGGER_MS = 60;
        var HIDE_DURATION = 250;

        function filterCards() {
            var hasLineFilter = selectedFilters.line.length > 0;
            var hasFormatFilter = selectedFilters.format.length > 0;

            // Clear any pending animation timers
            if (filterAnimationTimer) {
                clearTimeout(filterAnimationTimer);
                filterAnimationTimer = null;
            }

            var toShow = [];
            var toHide = [];

            productCards.forEach(function (card) {
                var cardLine = card.getAttribute('data-line');
                var cardFormat = card.getAttribute('data-format');

                var matchLine = !hasLineFilter || selectedFilters.line.indexOf(cardLine) !== -1;
                var matchFormat = !hasFormatFilter || selectedFilters.format.indexOf(cardFormat) !== -1;

                if (matchLine && matchFormat) {
                    toShow.push(card);
                } else {
                    toHide.push(card);
                }
            });

            // Phase 1: Hide non-matching cards with fade-out animation
            toHide.forEach(function (card) {
                // Only animate if currently visible
                if (!card.classList.contains('product-card--filter-hidden')) {
                    card.classList.remove('product-card--filter-reveal');
                    card.classList.add('product-card--filter-hide');

                    // After hide animation completes, truly hide
                    setTimeout(function () {
                        card.classList.remove('product-card--filter-hide');
                        card.classList.add('product-card--filter-hidden');
                    }, HIDE_DURATION);
                }
            });

            // Phase 2: After hide animation, reveal matching cards with staggered entrance
            var revealDelay = toHide.some(function (c) {
                return !c.classList.contains('product-card--filter-hidden');
            }) ? HIDE_DURATION + 30 : 0;

            filterAnimationTimer = setTimeout(function () {
                var staggerIndex = 0;

                toShow.forEach(function (card) {
                    var wasHidden = card.classList.contains('product-card--filter-hidden');

                    // Unhide
                    card.classList.remove('product-card--filter-hidden');
                    card.classList.remove('product-card--filter-hide');

                    if (wasHidden) {
                        // Staggered reveal animation
                        card.classList.remove('product-card--filter-reveal');
                        // Force reflow to restart animation
                        void card.offsetWidth;
                        card.style.setProperty('--stagger-delay', (staggerIndex * STAGGER_MS) + 'ms');
                        card.classList.add('product-card--filter-reveal');
                        staggerIndex++;

                        // Clean up animation class after it completes
                        var totalDelay = (staggerIndex * STAGGER_MS) + 550;
                        setTimeout(function () {
                            card.classList.remove('product-card--filter-reveal');
                            card.style.removeProperty('--stagger-delay');
                        }, totalDelay);
                    }
                });
            }, revealDelay);
        }

        // ---- Clear all filters ----
        function clearAllFilters() {
            selectedFilters.line = [];
            selectedFilters.format = [];

            desktopChips.forEach(function (c) {
                c.classList.remove('product-filter__chip--selected');
            });
            modalChips.forEach(function (c) {
                c.classList.remove('product-filter-modal__chip--selected');
            });

            updateAll();
        }

        // ---- URL hash → filter (line or format) ----
        function applyHashFilter() {
            var hash = window.location.hash.replace('#', '').toLowerCase();
            if (!hash) return;

            // Find a desktop chip with matching data-value (line or format)
            var matchedChip = null;
            var matchedFilter = null;
            desktopChips.forEach(function (c) {
                if (getChipValue(c) === hash) {
                    matchedChip = c;
                    matchedFilter = getChipKey(c);
                }
            });

            if (!matchedChip || !matchedFilter) return;

            // Clear existing filters silently (no updateAll yet)
            selectedFilters.line = [];
            selectedFilters.format = [];
            desktopChips.forEach(function (c) {
                c.classList.remove('product-filter__chip--selected');
            });
            modalChips.forEach(function (c) {
                c.classList.remove('product-filter-modal__chip--selected');
            });

            // Activate the matched filter
            selectedFilters[matchedFilter].push(hash);
            syncChips(matchedChip);
            updateAll();
        }

        // ---- Filter state → URL hash ----
        var isUpdatingHash = false;

        function updateHash() {
            isUpdatingHash = true;
            var totalCount = selectedFilters.line.length + selectedFilters.format.length;
            if (totalCount === 1) {
                var activeValue = selectedFilters.line[0] || selectedFilters.format[0];
                history.replaceState(null, '', '#' + activeValue);
            } else {
                history.replaceState(null, '', window.location.pathname + window.location.search);
            }
            isUpdatingHash = false;
        }

        // ---- Update everything ----
        function updateAll() {
            updateBadge();
            updateMobileTags();
            updateDesktopActiveRow();
            filterCards();
            updateHash();
        }

        // ---- Desktop chip clicks ----
        desktopChips.forEach(function (chip) {
            chip.addEventListener('click', function () {
                toggleChip(chip);
                syncChips(chip);
                updateAll();
            });
        });

        // ---- Modal chip clicks ----
        modalChips.forEach(function (chip) {
            chip.addEventListener('click', function () {
                toggleChip(chip);
                syncChips(chip);
                // Don't updateAll here — wait for "Pokaż wyniki"
            });
        });

        // ---- Open modal ----
        if (trigger) {
            trigger.addEventListener('click', function () {
                if (modal) {
                    modal.classList.add('product-filter-modal--open');
                    document.body.style.overflow = 'hidden';
                }
            });
        }

        // ---- Close modal ----
        function closeModal() {
            if (modal) {
                modal.classList.remove('product-filter-modal--open');
                document.body.style.overflow = '';
            }
        }

        if (modalClose) {
            modalClose.addEventListener('click', closeModal);
        }

        // Close on backdrop click
        if (modal) {
            modal.addEventListener('click', function (e) {
                if (e.target === modal) {
                    closeModal();
                }
            });
        }

        // ---- Clear all filters (modal) ----
        if (modalClear) {
            modalClear.addEventListener('click', clearAllFilters);
        }

        // ---- Clear all filters (desktop) ----
        if (clearBtn) {
            clearBtn.addEventListener('click', clearAllFilters);
        }

        // ---- Submit (apply) filters ----
        if (modalSubmit) {
            modalSubmit.addEventListener('click', function () {
                updateAll();
                closeModal();
            });
        }

        // ---- Listen for hash changes (e.g. back/forward navigation) ----
        window.addEventListener('hashchange', function () {
            if (!isUpdatingHash) {
                applyHashFilter();
            }
        });

        // ---- Initial state: apply hash filter or default ----
        if (window.location.hash) {
            applyHashFilter();
        } else {
            updateAll();
        }
    });
})();
